import Cta from '@atoms/Cta/Cta';
import Text from '@atoms/Text/Text';
import { ITextContent } from '@models/ITextContent';
import SiteEnum from '@models/enums/SiteEnum';
import classNames from 'classnames';

interface Props {
  readonly textContent: ITextContent;
  readonly site: SiteEnum;
}

const TextContent = ({
  textContent: { header, subText, ctas },
  site,
}: Props) => (
  <section className="tw-text-black-100 tw-flex tw-flex-col tw-gap-sm">
    <Text variant="headline">{header}</Text>
    <div
      className={classNames(
        'tw-rich-text tw-text-grey-80',
        site === SiteEnum.B2B && '[&_p]:tw-mb-6'
      )}
      dangerouslySetInnerHTML={{ __html: subText }}
    />

    <div className="tw-flex tw-flex-col tw-gap-3">
      {ctas?.map((cta) => (
        <div className="tw-inline-block" key={cta.text}>
          <Cta site={site} url={cta.url} target={cta.target} text={cta.text} />
        </div>
      ))}
    </div>
  </section>
);

export default TextContent;
